import Vue from 'vue'
import Vuex from 'vuex'
import firebase from './firebase'
//import firebase from 'firebase/app';
//import 'firebase/database';

//import { round, makeUSD }  from './js/numericFns'
//import { getMsec }  from './js/timeFns'

Vue.use(Vuex)
Vue.use(firebase)


/*
  let node = "messages/"
      console.log("~fb permits node",node)
  firebase.database.ref(node).once("value", function(snapshot){
    let snap = snapshot.val()
    if (snap==null) {
      // shouldn't get here - if so, exit
      alert("no data for node = " + node)
      return
    }

    console.log("number of parcels = ",Object.keys(snap).length)
    for (let [key, value] of Object.entries(snap)) {
        console.log(key, value)
        //messages.push(value)
    }
  })
*/

      //console.log("~fb permits lookup", snap)

      /*
      let i=0
      let j=0
      let k=0
      let permits = {}
      console.log("number of parcels = ",Object.keys(snap).length)
      for (let [key, value] of Object.entries(snap)) {
            //console.log(i,key, value)
        i++
        j=0
        permits = value.buildings.A.solar.permits
        for (let [key, value] of Object.entries(permits)) {
            //console.log(i,j,key, value)
          if (j>0) console.log("MULTIPLE PERMITS")
          j++
          k++

          let tokens = value.lngLat.split(",")
          const lng = tokens[0].trim()
          const lat = tokens[1].trim() 
          value.coords = [ Number(lng), Number(lat) ]

          solarSites.push(value)
        }
      }
      solarSitesLength = solarSites.length


      console.log("TOTAL permits added k=",k)
      //this.$store.dispatch('setLoading',"done")
      //setLoading: function (context, arg) {
      console.log("solarSites loaded from",loadSource,solarSites)
      // doesnt work
      //store.state.solarRows = solarSites


        // create assessor hash keyed by mapParcel
        if (loadAssessor==1) {
          node = "assessors/"
          firebase.database.ref(node).once("value", function(snapshot){
            console.log("~fb assessors lookup",node, snapshot.val())
            let snap = snapshot.val()
            // shouldn't get here - if so, exit
            if (snap==null) {
              alert("error at assessors/ load")
              return
            }
            console.log("assessors",snap)

            let mapAndParcel = ""
            console.log("assessors number of parcels = ",Object.keys(snap).length)
            for (let [key, value] of Object.entries(snap)) {
                  //console.log(i,key, value)
              mapAndParcel = value.Map+"-"+value.Parcel
                  //console.log("assessors = ",i,value)
              assessorMapParcel[mapAndParcel] = value
            }
            console.log("assessors hash of MapParcels assessorMapParcel = ",assessorMapParcel)

            // add this assessor mapParcel hash to Firebase
            node = "assess/mapParcels"
            console.log("set assess/mapParcels", node)
            // set to firebase
            //firebase.database.ref(node).set(assessorMapParcel);

          })
        }
        else if (loadAssessor==2) {
          node = "assess/mapParcels"
          firebase.database.ref(node).once("value", function(snapshot){
            assessorMapParcel = Object.assign(snapshot.val())
            console.log("~fb assess/mapParcels lookup",node, snapshot.val())
            //console.log("~fb assess/mapParcels lookup",node, assessorMapParcel)

            // shouldn't get here - if so, exit
            if (assessorMapParcel==null) {
              alert("error at assess/mapParcels load")
              return
            }
            console.log("assessors hash of MapParcels assessorMapParcel = ",assessorMapParcel)

          })
        }
        else if (loadAssessor!=0) {
          console.error("ERROR in store.js.  loadAssessor="+loadAssessor)
          //return
        }
        */

/*
#################### STATE ####################
#################### STATE ####################
#################### STATE ####################
#################### STATE ####################
#################### STATE ####################
#################### STATE ####################
#################### STATE ####################
#################### STATE ####################
#################### STATE ####################
#################### STATE ####################
*/

//export const store = new Vuex.Store({
export default new Vuex.Store({
  state: {

    loading: "",             // loading data
    debug: false,            // show debugging info

    messages: [],

    tableRows: [],        // copy of the data in the tee sheet table
    openings: [],

    history: {},          // log of changes to bookings
    sniffHistory: {},     // log of when each day was scraped
    sniffHistoryArr: [],  // array version of sniffHistory
    //sniffHistoryLast: {}, // last sniff history object
    selectIndex: 0,       // index of the dates array that is selected to display: default to today

    displayMode: 'desktop', // desktop, print, embed
    showYears: true,         // show the data years
    settings: {

        "showDiffs":    true,      // show the tee sheet diffs.  turned off to disable this feature

        preferredDayOfWeekSat: false,
        preferredDayOfWeekSun: false,
        preferredDayOfWeekMon: false,
        preferredDayOfWeekTue: false,
        preferredDayOfWeekWed: false,
        preferredDayOfWeekThu: false,
        preferredDayOfWeekFri: false,

        timePreferenceEarliest: "08:00 AM",
        timePreferenceLatest: "05:00 PM",
        show123Players: false,

        showDiffsViaAudio: false,
        audioClipSelected: "desk bell",

        showTextMessages: false,
        textMessagePhone: "",

        showTechnical: false,

    },

    // Vuex and Vue Computed Properties are not reactive
    // https://stackoverflow.com/questions/41851711/vuex-store-properties-not-reactive-when-using-computed-property
    // https://codepen.io/DedicatedManager/pen/JZgpaa
    // https://www.youtube.com/watch?v=8GHczab2Lbs&feature=youtu.be
    // https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats



    sniffing: {

      sniffed: ""

    },



    teeSheets: {

    /*     */
        d20200129: {
          stats: {
            tstamp: ""
          }
        },

      d20200130: {
          stats: {
            tstamp: ""
          }
        },
        d20200131: {
          stats: {
            tstamp: ""
          }
        },
        d20200201: {
          stats: {
            tstamp: ""
          }
        },
        d20200202: {
          stats: {
            tstamp: ""
          }
        },
        d20200203: {
          stats: {
            tstamp: ""
          }
        },
        d20200204: {
          stats: {
            tstamp: ""
          }
        },    
        // NEED TO CONTINUE THESE OUT UNTIL WE CAN FIGURE OUT HOW TO ADD PROGRAMMATICALLY

    },    // object whose properties are the various day's data (such as d20200129)

    cache: {
      "lastAccount": "",          // cache of the last account selected
    },

    //lastMsec: getMsec(),
  },

  /*
  #################### GETTERS ####################
  #################### GETTERS ####################
  #################### GETTERS ####################
  #################### GETTERS ####################
  #################### GETTERS ####################

  think of Getters as computed properties for stores. Like computed properties, 
  a getter's result is cached based on its dependencies, 
  and will only re-evaluate when some of its dependencies have changed.
  */

  getters: {

    status: state => state.status,

    selectedDate2: state => {
      return state.sniffing.teeSheetDates2[state.selectIndex]
    },
    selectedDate: state => {
      return state.sniffing.teeSheetDates[state.selectIndex]
    },

    /*
    dataConfig: state => id => {
      return state.dataConfig.filter(element => {
        return element.metric === id
      })[0]
    },
    geojsonName: (state, getters) => id => {
      return getters.dataConfig(id).geojson || state.dataOptions.defaultgeojson
    },
    */

    selected: state => payload => {
      return state.selected[payload]
    },

    // simple form. 
    showChoropleth: state => state.settings.showChoropleth
    //  reference in a component by:
    // $store.state.settings.showChoropleth
    //    OR
    // this.$store.getters.showChoropleth
    //    OR by:
    // computed: {
    //  showChoropleth() {
    //    return this.$store.getters.showChoropleth
    //  },
    // }
,

  },

  /*
  #################### MUTATIONS ####################
  #################### MUTATIONS ####################
  #################### MUTATIONS ####################
  #################### MUTATIONS ####################
  #################### MUTATIONS ####################
  #################### MUTATIONS ####################
  #################### MUTATIONS ####################
  #################### MUTATIONS ####################
  #################### MUTATIONS ####################
  #################### MUTATIONS ####################
  */

  mutations: {


    sniffHistory(state, payload) {

      state.sniffHistoryArr.unshift(payload)  // put it onto the front of the array


    },





    // https://www.jenniferbland.com/how-to-greatly-simplify-your-vuex-store/#more-1615
                              /*
                              // this mutates state.settings
                              mutateSettings(state, payload) {
                                  state.settings[payload.property] = payload.with;
                                  console.log("mutation state.settings."+payload.property, "setting to", payload.with)
                              },
                              // this mutates state
                              mutateState(state, payload) {
                                state[payload.property] = payload.with;
                                console.log("mutation state."+payload.property, "setting to", payload.with)
                              },
                              */
    // this mutates either state or state.<prop> depending on the form of payload.property
    // for example payload.property can = "settings.showMapVars" and this works
    mutate(state, payload) {
      const tokens = payload.property.split(".") // split the property at the .
      if (tokens.length==1) {
        // format: state.level1Property
        state[payload.property] = payload.with;

        Vue.set(payload, payload.property, payload.with)  // to make the property reactive

            console.log("store.js mutation state."+payload.property, "setting to", payload.with)
      }
      else {
        // format: state.level1Property.level2Property
        state[tokens[0]][tokens[1]] = payload.with;
            console.log("store.js mutation state."+tokens[0]+"."+tokens[1], "setting to", payload.with)
      }
    },
    // One approach to state is to create a string of characters to represent different sub-states
    // This string can be appended to and removed from, character by character
    // For example, loading multiple parallel data can be tracked individually, 
    //   by setting the state to the full string of expected loaded characters, and
    //   then removing them one a time as each loading takes place
    // Append string to the state variable
    mutateAppend(state, payload) {
      //console.log("store.js mutateAppend BEFORE",state[payload.property])
      state[payload.property] += payload.with;
      //console.log("store.js mutateAppend AFTER",state[payload.property])
    },
    // Remove string from the state variable (if not there, just ignore the fact)
    mutateRemove(state, payload) {
      console.log("store.js mutateRemove BEFORE",state[payload.property])
      state[payload.property] = state[payload.property].replace(payload.with, '')
      console.log("store.js mutateRemove AFTER",state[payload.property])
    },


  },

/*
#################### ACTIONS ####################
#################### ACTIONS ####################
#################### ACTIONS ####################
#################### ACTIONS ####################
#################### ACTIONS ####################
#################### ACTIONS ####################
#################### ACTIONS ####################
#################### ACTIONS ####################
#################### ACTIONS ####################
#################### ACTIONS ####################
*/

  actions: {

    /*
    // various settings
    setShowDiffs: function (context, arg) {
      if (arg==null) arg=false
      context.commit('mutate', {
        property: "settings.showDiffs",
        with: arg
      });
    },
    */

    // generic settings properties setter
    // arg contains the settingName and the value to set
    // e.g., 
    //  this.$store.dispatch( 'setSettings', {"settingName":"showDiffs","value":newVal} )
    //
    setSettings: function (context, arg) {
      if (arg==null) {
        arg=false
        return
      }
      // is the arg not an object with property settingName?
      if (typeof arg != "object") {
        context.commit('mutate', {
          property: "settings.showDiffs",
          with: arg
        });
      }
      // arg is an object { settingName, value }
      else {
        context.commit('mutate', {
          property: "settings."+arg.settingName,
          with: arg.value
        });
      }

    },

    //
    // generic settings properties setter
    // arg contains the settingName and the value to set
    // e.g., 
    //  this.$store.dispatch( 'setState', {"stateName":"settings","stateChild":"showDiffs","value":newVal} )
    // stateChild is optional and can be omitted from the object
    //
    setState: function (context, arg) {
      if (arg==null || typeof arg != "object") {
        console.error("setState arg == null || != object")
        return
      }
      // arg is an object { stateName, stateChild, value }
      else {
        if (arg.stateChild!=undefined) {
          context.commit('mutate', {
            property: arg.stateName+"."+arg.stateChild,
            with: arg.value
          });
        }
        else {
          context.commit('mutate', {
            property: arg.stateName,
            with: arg.value
          });
        }

      }
    },

    // call: this.$store.dispatch( 'setState', {"stateName":"selectIndex","value":this.selectedIndex} )
    setSelectedIndex: function (context, arg) {
          context.commit('mutate', {
            property: arg.stateName,
            with: arg.value
          });
          firebase.database.ref('/queue/dateIndex').set(arg.value).then(() => {
            //console.log("SET FIREBASE with "+arr.length+" openingsPrior");
          });
          /*
          firebase.database.ref('/queue').push(arg.value).then(() => {
            //console.log("SET FIREBASE with "+arr.length+" openingsPrior");
          });
          */
    },

    setOpeningsPrior: function (context) {
      console.log("setOpeningsPrior",context)
      const user = "beb"
      let arr = []
      arr = this.state.openings
      console.log("setOpeningsPrior arr",arr)

      // set the openings array into firebase (must SET an array)
        const node = '/users/'+user+'/openingsPrior';
        console.log("openingsPrior ready to SET FIREBASE with "+node+" = "+arr.length+"");
        firebase.database.ref(node).set(arr).then(() => {
            console.log("SET FIREBASE with "+arr.length+" openingsPrior");
        });
    },

    /*
        https://www.jenniferbland.com/how-to-greatly-simplify-your-vuex-store/#more-1615

        context.commit('mutate', {
          property: <propertyNameHere>,
          with: <valueGoesHere>
        });
    */


    //
    // called from create hook in main.js
    // loads settings and cache
    //
    loadUserParams: function (context, arg) {
      console.warn("store.js action loadUserParams , arg=", arg)

        // update loading state to signal that S loading has started
        context.commit('mutateAppend', {
          property: "loading",
          with: arg
        });

      // https://firebase.google.com/docs/reference/node/firebase.database.DataSn
      const node = "user"

      console.warn("store.js action loadUserParams , node=", node)

      var query = firebase.database.ref(node)
      query.once("value")
        .then(function(snapshot) {
          snapshot.forEach(function(childSnapshot) {

            let key = childSnapshot.key;

            if (key=="settings") {
              var settings = childSnapshot.val();
              settings.now = ""
            }
            else if (key=="cache") {
              var cache = childSnapshot.val();
              cache.now = ""
            }
        });
        // update loading state to signal that S loading has completed
        context.commit('mutateRemove', {
          property: "loading",
          with: arg
        });

      })

    },

    storeUserParams: function (context, arg) {
      console.warn("store.js action     storeUserParams arg=",arg)

        // update loading state to signal that S loading has started
        context.commit('mutateAppend', {
          property: "loading",
          with: "s"
        });

      // https://firebase.google.com/docs/reference/node/firebase.database.DataSn
      const node = "user"
      var query = firebase.database.ref(node)
      query.once("value")
        .then(function(snapshot) {
          snapshot.forEach(function(childSnapshot) {

            let key = childSnapshot.key;

            if (key=="settings") {
              var settings = childSnapshot.val();
              settings.now = ""

            }
            else if (key=="cache") {
              var cache = childSnapshot.val();
              cache.now = ""

            }
        });
        // update loading state to signal that S loading has completed
        context.commit('mutateRemove', {
          property: "loading",
          with: "s"
        });

      })

    },

    //
    // called from the scraper to load anything from the fbase,
    // and to set the listeners on
    //


    loadFirebaseData: function (context) {
      console.log("loadFirebaseData")
      let sniffHistoryLast = {} // last sniff history object

      // update loading state to signal that S(niffing) and T(eeSheet) loading has started

      context.commit('mutateAppend', {
        property: "loading",
        with: "S"
      });

      let node = ""

        // if the node sniffing changes, then read it and put into store
        node = "sniffing/"
        firebase.database.ref(node).on("value", function(snapshot){
          let snap = snapshot.val()
          if (snap==null) {
            // shouldn't get here - if so, exit
            console.warn("ON: no data for node = " + node)
          }
          else {
            console.log("ON sniff sniffed",snap.sniffed)
            console.log("ON sniff teeSheetDate",snap.teeSheetDate)
            console.log("ON sniff teeSheetDate2",snap.teeSheetDate2)
            console.log("ON sniff teeSheetDates2",snap.teeSheetDates2)

            context.commit('mutate', {
              property: "sniffing",
              with: snap
            });
            console.log("ON commit node=", node, "snap=", snap)
            //console.log("DAYS = ",this.state.sniffing)

            // update loading state to signal that S loading has completed
            context.commit('mutateRemove', {
              property: "loading",
              with: "S"
            });
            // set loading to anticipate the various teeSheets (add their indices to the loading string)
            for (let j=0; j<snap.teeSheetDates2.length; j++) {
              // don't assume last tee sheet is posted yet, so don't make it a loading condition
              if (j<5) {
                context.commit('mutateAppend', {
                  property: "loading",
                  with: String(j)
                });
              }
            }

            // loop through all tee sheet dates
            let nd = ""
            for (let i=0; i<snap.teeSheetDates2.length; i++) {
              nd = "teeSheets/d"+snap.teeSheetDates2[i]
                      console.log("ON sniff i",i,nd)
              //e.g., nd = "d20200130"
              firebase.database.ref(nd).on("value", function(snapshot){
                let snap = snapshot.val()
                if (snap==null) {
                  // shouldn't get here - if so, exit
                      console.warn("no data for node = " + nd)
                }
                else {
                      console.log("ON snap teeSheetDate2 openings openByHour",snap.stats.teeSheetDate2,snap.stats.openings,snap.openByHour)
                  context.commit('mutate', {
                    property: "teeSheets."+snapshot.key,
                    with: snap
                  });
                      console.log("ON commit node snap",snapshot.key, snap)
                }


                  // update loading state to signal that this T(eeSheet) loading has completed
                  context.commit('mutateRemove', {
                    property: "loading",
                    with: String(i)
                  });

              })
            }

            console.log("SETUP LISTENERS FOR EACH OF THE DAY THAT TEE SHEETS ARE ACTIVE.")
            //console.log("STATE",this.state)
            
          }
        })




        node = "history"
        console.log("node = ",node)
        firebase.database.ref(node).limitToLast(500).on("value", function(snapshot){
          let snapH = snapshot.val()
          console.log("snapH = ",snapH)
          if (snapH==null) {
            // shouldn't get here - if so, exit
            console.warn("no data for node = " + node)
          }
          else {          
            context.commit('mutate', {
              property: "history",
              with: snapH
            });
          }
        })

        node = "sniffHistory"
        console.log("node = ",node)
        // limit the number retrieved since this is triggered each time a tee sheet is crawled
        //
        /* NOTE - it might be better to retrieve this data whenever the user requests a crawling log detail
            That would prevent it being retrieved all the time and using a lot of download bandwidth
            The last log is set into fb node sniffHistoryLast
            This can be listened to, and then added to the store
        */
        //

        // read the history log
        // and use it to update the history array, just once to initialize it
        firebase.database.ref(node).limitToLast(100).once("value", function(snapshot){
          let snapSH = snapshot.val()
          console.log("snapSH = ",snapSH)
          if (snapSH==null) {
            // shouldn't get here - if so, exit
            console.warn("no data for node = " + node)
          }
          else {
            // turn into an array first
            let shArr = []
            for (const shItem in snapSH) {
              shArr.unshift(snapSH[shItem])  // put it onto the front of the array
            }
              /*
              //let shObj = {}
              for (const shItem in snapSH) {
              for (const [key, value] in snapSH) {
              for (const prop in shItem) {
                //if (prop=='tStamp') shObj.tstamp = prop.value
                shObj[prop] = prop.value
              }
              //shObj = {}
              //shObj.tstamp = shItem
              console.log("key=",key)
              console.log("value=",value)
                            shArr.unshift(value)  // put it onto the front of the array
              */
              //console.log("shItem=",snapSH[shItem].tstamp)

            /*              */
            console.log("shArr = ",shArr)
            context.commit('mutate', {
              property: "sniffHistoryArr",
              with: shArr
            });

            context.commit('mutate', {
              property: "sniffHistory",
              with: snapSH
            });
          }

          // set the listener to listen to just the last log write
          // and use it to update the history array
          node = "sniffHistoryLast"
          firebase.database.ref(node).on("value", function(snapshot){
            let snapSHL = snapshot.val()
            let dupe = false;
            if (snapSHL.timestamp==sniffHistoryLast.timestamp) dupe=true
            console.log("snapSHL",dupe,snapSHL.tstamp,snapSHL)
            sniffHistoryLast = snapSHL
            // if we have a new sniff log, then let's update the store array
            if (!dupe) {
              context.commit('sniffHistory', snapSHL);
              //sniffHistory(state, payload) {
              //this.state.sniffHistoryArr.unshift(snapSHL)  // put it onto the front of the array
            }

          })

        })

                                    const doThis = false;
                                    if (doThis) {
                                      console.log("SETUP LISTENERS FOR EACH OF THE DAY THAT TEE SHEETS ARE ACTIVE.")
                                      console.log("STATE",this.state)
                                      node = "d20200130"
                                      firebase.database.ref(node).on("value", function(snapshot){
                                        let snap = snapshot.val()
                                        if (snap==null) {
                                          // shouldn't get here - if so, exit
                                          console.warn("no data for node = " + node)
                                        }
                                        else {
                                          //console.log("snap sniffed",snap)
                                          console.log("ON snap teeSheetDate2 openings openByHour",snap.stats.teeSheetDate2,snap.stats.openings,snap.openByHour)
                                          context.commit('mutate', {
                                            property: snapshot.key,
                                            with: snap
                                          });
                                          console.log("ON commit node snap",snapshot.key, snap)
                                        }
                                      })
                                      node = "d20200128"
                                      firebase.database.ref(node).on("value", function(snapshot){
                                        let snap = snapshot.val()
                                        if (snap==null) {
                                          // shouldn't get here - if so, exit
                                          console.warn("no data for node = " + node)
                                        }
                                        else {
                                          //console.log("snap sniffed",snap)
                                          console.log("ON snap teeSheetDate2 openings openByHour",snap.stats.teeSheetDate2,snap.stats.openings,snap.openByHour)
                                          context.commit('mutate', {
                                            property: snapshot.key,
                                            with: snap
                                          });
                                          console.log("ON commit node snap",snapshot.key, snap)
                                        }
                                      })
                                      node = "d20200129"
                                      firebase.database.ref(node).on("value", function(snapshot){
                                        let snap = snapshot.val()
                                        if (snap==null) {
                                          // shouldn't get here - if so, exit
                                          console.warn("no data for node = " + node)
                                        }
                                        else {
                                          //console.log("snap sniffed",snap)
                                          console.log("ON snap teeSheetDate2 openings openByHour",snap.stats.teeSheetDate2,snap.stats.openings,snap.openByHour)
                                          context.commit('mutate', {
                                            property: snapshot.key,
                                            with: snap
                                          });
                                          console.log("ON commit node snap",snapshot.key, snap)
                                        }
                                      })
                                      node = "tableRows/"
                                      firebase.database.ref(node).on("value", function(snapshot){
                                        let snap = snapshot.val()
                                        if (snap==null) {
                                          // shouldn't get here - if so, exit
                                          console.warn("no data for node = " + node)
                                        }
                                        else {
                                          let tableRowsLoaded = [];
                                          tableRowsLoaded.length = 0;
                                          console.log("number of tableRowsLoaded = ",Object.keys(snap).length)
                                          for (let [key, value] of Object.entries(snap)) {
                                              //console.log(key, value)
                                              const kk = key // eslint-disable-line no-unused-vars
                                              tableRowsLoaded.push(value)
                                          }
                                          console.log(tableRowsLoaded)
                                          console.log(tableRowsLoaded.length)
                                          context.commit('mutate', {
                                            property: "tableRows",
                                            with: tableRowsLoaded
                                          });
                                        }
                                      })
                                      node = "openings"
                                      console.log("node = ",node)
                                      firebase.database.ref(node).on("value", function(snapshot){
                                        let snap2 = snapshot.val()
                                        console.log("snap2 = ",snap2)
                                        if (snap2==null) {
                                          // shouldn't get here - if so, exit
                                          console.warn("no data for node = " + node)
                                        }
                                        else {
                                          let rowsLoaded = [];
                                          rowsLoaded.length = 0;
                                          console.log("number of openings = ",Object.keys(snap2).length)
                                          for (let [key, value] of Object.entries(snap2)) {
                                              //console.log(key, value)
                                              const kk = key // eslint-disable-line no-unused-vars
                                              rowsLoaded.push(value)
                                          }
                                          console.log(rowsLoaded)
                                          console.log(rowsLoaded.length)
                                          context.commit('mutate', {
                                            property: "openings",
                                            with: rowsLoaded
                                          });
                                          // load the openings into the store for the date of the tee sheet
                                          //const nodeDate = rowsLoaded[0].teeSheetDate2
                                          //const nodeDate2 = "20200126"
                                          const nodeDate2 = rowsLoaded[0].teeSheetDate2
                                          let prop = "d"+nodeDate2
                                          if ( this!=null && this.state[prop] === undefined ) {
                                            context.commit('mutate', {
                                              property: prop,
                                              with: []
                                            });
                                          }
                                          prop = "d"+nodeDate2+".openings"
                                          context.commit('mutate', {
                                            property: prop,
                                            with: rowsLoaded
                                          });
                                        }
                                      })



                                    }

      },

  }
})
